export enum GuidRepresentation {
    Unspecified,
    Standard,
    CSharpLegacy,
    JavaLegacy,
    PythonLegacy
}